module.exports = __webpack_public_path__ + "static/media/ke.c199af50.svg";